<template>
  <b-modal
    :id="nameId+'Modal'"
    :ref="nameId+'Modal'"
    hide-header
    hide-footer
    modal-class="success-submit-modal"
    ignore-enforce-focus-selector=".webim-root"
  >
    <div class="modal__wrapper">
      <div
        class="modal__close"
        @click="() => {hideSuccessModal()}"
      />

      <div :class="[success ? 'success-message' : 'error-message']">
        <span :class="[success ? 'success-message' : 'error-message'] + '__icon'" />
        <div
          :id="nameId+'Message'"
          :class="[success ? 'success-message' : 'error-message']
            +'__text'"
          v-html="message"
        />
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'FormSendSuccess',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      nameId: this.type,
      success: true,
      message: '',
      successDefault: true,
      messageDefault: '<p>Ваша заявка отправлена!</p><span>Мы с вами свяжемся в ближайшее время</span>',
    };
  },
  mounted() {
    document.addEventListener('popup-message', (e) => {
      this.message = e.detail.message || this.messageDefault;
      this.success = e.detail.success || this.successDefault;
      if (e.detail.success === false) {
        this.success = false;
      }
      this.showModal();
    });
  },
  methods: {
    hideSuccessModal() {
      this.$bvModal.hide(`${this.nameId}Modal`);
    },
    showModal() {
      this.$bvModal.show(`${this.nameId}Modal`);
    },
  },
};
</script>

<style lang="scss">
  @import 'PopupMessage';
</style>
